import React from "react";
import jQuery from 'jquery';
import CoalesceFunction from "../../../helper/coalesceFunction";
import {travianFeatures} from "../../../travianCore";

const InputType = {
    JSON: 'JSON',
    HTML: 'HTML',
    TEXT: 'TEXT',
}

function getInputType(clipboardData) {
    const clipboardText = clipboardData.getData('text');

    switch(true) {
        case clipboardText.indexOf('<html') !== -1:
        default:
            return InputType.HTML;
        case clipboardText.indexOf('{') === 0:
            return InputType.JSON;
        case clipboardText.indexOf('<!DOCTYPE') !== -1:
            return InputType.TEXT;
    }
}

function getInputData(clipboardData, inputDataType) {
    switch(inputDataType) {
        case InputType.JSON:
            return JSON.parse(clipboardData.getData('text'));
        case InputType.HTML:
            return jQuery(jQuery.parseHTML(clipboardData.getData('text/html')));
        case InputType.TEXT:
            return jQuery(jQuery.parseHTML(clipboardData.getData('text')));
    }
}

function selectParser(parser) {
    switch(travianFeatures.baseVersion) {
        case 4:
            return parser?.parseLegends;
        case 5:
            return parser?.parseKingdoms;
        default:
            return null;
    }
}

/**
 *
 * @param domParsers {array} Array of DOM parsers, if input is HTML.
 * @param jsonMappers {array} Array of JSON mappers, if input is JSON.
 * @param parsedDataHandler {function} Function to accept output of parsers or mappers.
 * @param wrongInputHandler {function} Function to be called, if the input can't be parsed.
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export default function ParserInput({ domParsers, jsonMappers, parsedDataHandler, wrongInputHandler, ...props }) {
    jsonMappers = jsonMappers ?? [];
    domParsers = domParsers ?? [];
    if(domParsers.length > 0 && jsonMappers.length > 0 && domParsers.length !== jsonMappers.length) {
        throw new Error('If domParsers and jsonMappers are given, their amount must match.');
    }

    return (
        <div
            className='copy-paste-parser'
            onPaste={(event) => {
                event.preventDefault();
                const clipboardData = event.clipboardData;
                const inputDataType = getInputType(clipboardData);
                const inputData = getInputData(clipboardData, inputDataType);
                let outputData;
                switch(inputDataType) {
                    case InputType.JSON:
                        outputData = jsonMappers.map(mapper => CoalesceFunction(mapper)(inputData));
                        break;
                    case InputType.HTML:
                    case InputType.TEXT:
                        outputData = domParsers.map(parser => CoalesceFunction(selectParser(parser))(inputData));
                        break;
                }
                if(outputData.length > 0) {
                    parsedDataHandler(outputData);
                }
                else {
                    CoalesceFunction(wrongInputHandler)();
                }
            }}
            contentEditable={true}
            {...props}
            />
    )
}
